import { ExternalLink } from 'lucide-react';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '@/components/ui/table';
import type { SponsorCreditRow, SponsorHackerOption } from '@/types';
import { DeleteSponsorCreditDialog } from './DeleteSponsorCreditDialog';
import { EditSponsorCreditDialog } from './EditSponsorCreditDialog';

interface SponsorCreditsTableProps {
  sponsorId: string;
  sponsorSlug: string;
  eventSlug: string;
  credits: SponsorCreditRow[];
  hackerOptions: SponsorHackerOption[];
}

export function SponsorCreditsTable({
  sponsorId,
  sponsorSlug,
  eventSlug,
  credits,
  hackerOptions,
}: SponsorCreditsTableProps) {
  if (credits.length === 0) {
    return (
      <div className="p-8 text-center text-muted-foreground">
        <p>No credits found.</p>
      </div>
    );
  }

  return (
    <div className="rounded-md border">
      <Table>
        <TableHeader>
          <TableRow>
            <TableHead className="w-[240px]">Hacker</TableHead>
            <TableHead>Notes</TableHead>
            <TableHead className="w-[260px]">URL</TableHead>
            <TableHead className="w-[140px]">Actions</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {credits.map((credit) => (
            <TableRow key={credit.id}>
              <TableCell>
                <div className="font-medium text-sm">{credit.hackerName}</div>
                <div className="text-muted-foreground text-xs">
                  {credit.hackerEmail}
                </div>
              </TableCell>
              <TableCell>
                <div className="line-clamp-3 whitespace-pre-wrap text-muted-foreground text-sm">
                  {credit.notes || '-'}
                </div>
              </TableCell>
              <TableCell>
                {credit.url ? (
                  <a
                    href={credit.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-flex items-center gap-1 break-all text-muted-foreground text-sm hover:text-foreground"
                  >
                    <ExternalLink className="h-3 w-3 shrink-0" />
                    {credit.url}
                  </a>
                ) : (
                  <span className="text-muted-foreground">-</span>
                )}
              </TableCell>
              <TableCell>
                <div className="flex items-center gap-1">
                  <EditSponsorCreditDialog
                    sponsorId={sponsorId}
                    sponsorSlug={sponsorSlug}
                    eventSlug={eventSlug}
                    credit={credit}
                    hackerOptions={hackerOptions}
                  />
                  <DeleteSponsorCreditDialog
                    creditId={credit.id}
                    sponsorSlug={sponsorSlug}
                    eventSlug={eventSlug}
                    hackerName={credit.hackerName}
                  />
                </div>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </div>
  );
}
